module.exports = __webpack_public_path__ + "img/05_no.6434c8e2.svg";